
import React from 'react';
import { FileCheck, ArrowUpRight } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

interface ActionsTableProps {
  actionItems: string[];
}

export const ActionsTable = ({ actionItems }: ActionsTableProps) => {
  return (
    <div className="p-4">
      <h3 className="text-sm font-semibold mb-2 flex items-center">
        <FileCheck className="h-4 w-4 mr-1 text-primary" /> 
        Key Actions Performed
      </h3>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[50px]">#</TableHead>
            <TableHead>Action Type</TableHead>
            <TableHead className="text-right">Impact</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {actionItems.slice(0, 5).map((action, index) => (
            <TableRow key={index}>
              <TableCell className="font-mono">{index + 1}</TableCell>
              <TableCell>{action}</TableCell>
              <TableCell className="text-right">
                <span className={
                  index % 3 === 0 
                    ? "text-green-500 flex items-center justify-end" 
                    : index % 3 === 1 
                      ? "text-amber-500 flex items-center justify-end" 
                      : "text-blue-500 flex items-center justify-end"
                }>
                  {index % 3 === 0 && "High "}
                  {index % 3 === 1 && "Medium "}
                  {index % 3 === 2 && "Low "}
                  <ArrowUpRight className="h-3 w-3 ml-1" />
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
